<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5">
    <div class="container">
     <div class="">
      <div class="row mt-2 mt-md-0">
  
          <aside class="col-sm-6 col-md-4 col-lg-3">
            <app-userdashboard-sidebar>  </app-userdashboard-sidebar>  
                      </aside>
                      <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">
                        <app-userheading-section></app-userheading-section>
                    
                        <div class="row">

                            <div class="col-md-6 mb-4" *ngFor="let adr of addAr; let i = index">
                                <div class="profile-content h-100">

                                    <h3>
                                        <span *ngIf="adr.isDefault ==0">{{ 'myaccount.ship_address' | translate }}</span>
                                        <span *ngIf="adr.isDefault !=0">{{ 'myaccount.def_address' | translate }}</span>
                                        <a class="edit-info" [routerLink]="['/my-account/editaddress', adr.id]"><svg class="svg-inline--fa fa-pencil-alt fa-w-16" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="pencil-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"></path></svg> {{ 'myaccount.edit' | translate }}</a></h3>
                                    <ul>
                                        <li> <span>{{ 'myaccount.name' | translate }}: </span> {{adr.userName}} </li>
                                        <li><span>{{ 'myaccount.phone' | translate }} :</span> {{adr.phoneNumber}}</li>                                        
                                        <li> <span> {{ 'myaccount.address' | translate }}: </span> {{adr.address_one}} </li>
                                        <li> <span>{{ 'myaccount.villa' | translate }}: </span> {{adr.apartment}} </li>
                                        <li> <span> {{ 'myaccount.landmark' | translate }}: </span> {{adr.address_two}} </li>
                                        <li><span>{{ 'myaccount.city' | translate }}:</span> {{adr.city}}</li>
                                        <li><span>{{ 'myaccount.state' | translate }} :</span> {{adr.state}}</li>
                                        <li><span>{{ 'myaccount.country' | translate }} :</span> {{adr.country}}</li>
                                    </ul>	
                                </div>
                          </div>

              <div class="col-md-12"> 
                <a class="btn btn-primary btn-lg btn-block comm-btn" [routerLink]="['/','my-account','add-address']">{{ 'myaccount.add_new_address' | translate }}</a>
              </div>

  </div>


</div>
                  </div>
              </div>
          </div>
      </section>